import apiClient from './ApiClient';

export class StaffRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/staff';
	}

	async list() {
		return this.client.get(this.basePath);
	}

	async invite(payload) {
		return this.client.post(`${this.basePath}/invite`, payload);
	}

	async listPendingInvitations() {
		return this.client.get(`${this.basePath}/invitations/pending`);
	}

	async resendInvitation(invitationId) {
		return this.client.post(`${this.basePath}/invitations/${invitationId}/resend`);
	}

	async revokeInvitation(invitationId) {
		return this.client.delete(`${this.basePath}/invitations/${invitationId}`);
	}

	async acceptInvitation(payload) {
		return this.client.post(`${this.basePath}/invitations/accept`, payload);
	}

	async updateRole(userId, role) {
		return this.client.patch(`${this.basePath}/${userId}/role`, { role });
	}

	async disable(userId) {
		return this.client.patch(`${this.basePath}/${userId}/disable`);
	}

	async enable(userId) {
		return this.client.patch(`${this.basePath}/${userId}/enable`);
	}
}

export default new StaffRepository(apiClient);
